"use client";

import Box from "@mui/material/Box";
import { FormFunnelRichText } from "@portal/app/_components/formFunnel/FormFunnelRichText";
import { LandingPageBlock } from "../../components/LandingPageBlock";
import type { PageMedia, ResolvedPageContentBlock } from "../../types";
import { hydratePuckRichTextMedia } from "../designHelpers";

type TextBlock = Extract<ResolvedPageContentBlock, { blockType: "richText" }>;

/** Body copy follows the site's responsive text scale; existing text keeps its chosen size. */
export function PageText({
  block,
  typography = "standard",
  media = [],
}: {
  block: TextBlock;
  typography?: "standard" | "body" | "footer" | "article" | "finePrint";
  media?: readonly PageMedia[];
}) {
  const content = hydratePuckRichTextMedia(block.resolvedContent.content, media);
  if (typography === "standard")
    return <LandingPageBlock block={{ ...block, resolvedContent: { content } }} />;
  if (typography !== "body") {
    return (
      <FormFunnelRichText
        content={content}
        appearance={typography === "footer" ? "footer" : "article"}
        tone={typography === "finePrint" ? "finePrint" : "body"}
      />
    );
  }
  const color = block.background === "brand" ? "common.white" : "text.secondary";
  return (
    <Box
      sx={{
        minWidth: 0,
        fontSize: "1rem",
        fontWeight: 400,
        lineHeight: 1.45,
        textAlign: block.align,
        color,
        "&& > div": { color, textAlign: block.align },
        "&& p, && li": {
          fontSize: "1rem",
          fontWeight: 400,
          lineHeight: 1.45,
          textAlign: block.align,
        },
        "& p:last-child": { mb: 0 },
        ...(block.background === "brand"
          ? {
              "&& :is(h1, h2, h3, h4, h5, h6, p, li, a, blockquote, strong, em)": {
                color: "common.white",
              },
            }
          : {}),
      }}
    >
      <FormFunnelRichText content={content} appearance="article" />
    </Box>
  );
}
